import axiosInstance from "@/api/proxyHandler";

export default {
    /**
     * 갱신 기능 공개 여부 (좌측 메뉴 노출)
     *
     * 정식 오픈 전에는 서버가 지정한 테스터 계정만 true 다. 테스터 목록은 서버에만 있다.
     *
     * @returns {Promise} { enabled }
     */
    async getRenewalAccess() {
        return await axiosInstance.get(`/renewals/access`)
    },

    /**
     * 갱신 대상자 여부 (갱신안내 팝업)
     *
     * 대상이 아니거나 CMS 조회에 실패하면 isTarget=false 로 내려온다.
     *
     * @returns {Promise} { isTarget, memberName, membershipName, expireAt }
     */
    async getRenewalTarget() {
        return await axiosInstance.get(`/renewals/target`)
    },

    /**
     * 갱신 가능 멤버십 목록
     *
     * 관리자가 등록·노출 설정한 상품만 내려온다. price 는 화면 표시용이며,
     * 실제 결제금액은 주문 생성 시 서버가 renewal_membership 에서 다시 확정한다.
     *
     * 갱신 혜택(renewalBenefitList)은 **갱신 기간 안에서만** 내려온다.
     * 기간이 지나면 빈 배열 + renewalBenefitExposed=false 다 — 앱이 날짜를 계산해 숨기지 않는다.
     * renewalDeadline / renewalBenefitExposed 는 회원당 한 값이지만 행마다 같은 값으로 실려 온다.
     *
     * @param {String} [yyyy] 판매년도. 생략하면 서버가 올해로 판단한다.
     * currentMembership* 는 서버가 **갱신 판정에 실제로 쓴** 발급 멤버십이다.
     * 상단 "현재 이용 중인 멤버십" 카드는 반드시 이 값을 써야 한다 —
     * GET /v1/memberships 는 정렬이 없어 여러 건 보유 회원에서 다른 멤버십이 뽑힐 수 있다.
     *
     * @returns {Promise} [{ id, name, price, benefitList, renewalBenefitList, renewalDeadline,
     *                       renewalBenefitExposed, currentMembershipName, currentMembershipStartAt, currentMembershipEndAt }]
     */
    async getRenewalMemberships(yyyy) {
        return await axiosInstance.get(`/renewals/memberships`, {params: yyyy ? {yyyy} : {}})
    },

    /**
     * 결제 주문 생성 (KICC EasyPay 거래등록)
     *
     * 금액·상품명은 보내지 않는다. 서버가 renewalMembershipId 로 확정한다.
     * 응답의 authPageUrl 로 이동하면 PG 결제창이 열린다.
     *
     * @param {Object} model
     * @param {Number} model.renewalMembershipId 선택한 갱신 멤버십 id
     * @param {String} model.deviceType "pc" | "mobile"
     * @param {Boolean} model.termsAgreed 멤버십 이용약관 필수 동의 여부. true 가 아니면 서버가 거부한다.
     * @returns {Promise} { paymentId, shopOrderNo, amount, authPageUrl }
     */
    async createPaymentOrder(model) {
        return await axiosInstance.post(`/payments/easypay/orders`, {
            ...model
        })
    },

    /**
     * 갱신 이력 목록 (기획서 9p) — 본인 건만
     */
    async getRenewalHistories() {
        return await axiosInstance.get(`/renewals/histories`)
    },

    /**
     * 갱신 이력 상세 (기획서 11p) — 본인 건만
     */
    async getRenewalHistory(paymentId) {
        return await axiosInstance.get(`/renewals/histories/${paymentId}`)
    },

    /**
     * 취소/환불 신청 — 접수만 하고 실제 처리는 관리자가 한다.
     */
    async requestRefund(paymentId) {
        return await axiosInstance.post(`/renewals/payments/${paymentId}/refund-request`)
    },

    /**
     * 결제 상세 조회 (본인 건만)
     */
    async getPayment(paymentId) {
        return await axiosInstance.get(`/payments/easypay/${paymentId}`)
    },
}
